<template>
    <div class="form-group">
        <label :for="getFieldId" v-text="placeholder"></label>
        <select :value="value"
                :name="name"
                :id="getFieldId"
                :required="required"
                :readonly="readonly"
                :disabled="disabled"
                class="form-control"
                @change="updateValue($event.target.value)">
            <option v-for="timezone in timezones" :value="timezone.name" v-text="timezone.name"></option>
        </select>
    </div>
</template>
<script>

    let InputField = require('@/mixins/InputField');

    export default {

        mixins: [InputField],

        data() {
            return {
                timezones: [],
            }
        },

        created() {
            this.timezones = moment.tz.names()
                .reduce((memo, tz) => {
                    memo.push({
                        name: tz,
                        offset: moment.tz(tz).utcOffset()
                    });
                    return memo;
                }, [])
        },
    }
</script>